<template>
    <div id="meltingspot-frame" style="width: 100%; height: 100%" />
</template>
<script>
export default {
    props: {
        spotId: {
            type: String,
            required: true,
        },
        authToken: {
            type: String,
            required: true,
        },
        themeMode: {
            type: String,
            default: 'light',
        },
    },
    mounted() {
        window.addEventListener('DOMContentLoaded', this.initMeltingSpot());
    },
    methods: {
        initMeltingSpot() {
            window.MeltingSpot.injectSpotInto('meltingspot-frame', {
                spotId: this.spotId,
                themeMode: this.themeMode,
                authToken: this.authToken,
            });
        },
    },
};
</script>

<style lang="scss">
body.page-academy .global {
    background-color: var(--colors-common-background-default);
}
</style>
